// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__36eoy","info":"PatientInfo_info__2hAOW"};